<template>
    <DefaultLayoutVue>
        a
    </DefaultLayoutVue>
</template>

<script>
import DefaultLayoutVue from './layout/DefaultLayout.vue'

export default {
    components: {DefaultLayoutVue}
}
</script>
